import { render, staticRenderFns } from "./ModalUploadFile.vue?vue&type=template&id=3afb2eac"
import script from "./ModalUploadFile.vue?vue&type=script&lang=js"
export * from "./ModalUploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports